import gql from 'graphql-tag';

const CourtApplicationTemplate = gql`
  query COURT_APPLICATION_TEMPLATE_QUERY(
    $id: ID!
    $options: CourtApplicationTemplatePresectionOptions
    $documentIds: [ID]
  ) {
    claim(id: $id) {
      id
      courtApplicationTemplate(
        options: $options
        documentIds: $documentIds
      ) {
        sectionsGroups {
          name
          sections {
            name
            fields
            template
          }
        }
        fields {
          id
          name
          value
          type
          icon
        }
      }
    }
  }
`;

export { CourtApplicationTemplate };



// WEBPACK FOOTER //
// ./src/queries/CourtApplicationTemplate.js